import React from "react";
import CartBadge from "./CartBadge";
import Logo from "core/assets/icons/Logo";
import UserAvatar from "core/assets/icons/header/user.svg";
import { useCustomNavigate } from "core/hooks/useCustomNavigate";
import { route, RouterName } from "core/router";
import { useSelector } from "react-redux";
import SearchIcon from "modules/Main/assets/icon/icon_search.svg";
import Bell from "./Bell";

const MainHeader: React.FC = () => {
  const navigate = useCustomNavigate();
  const userInfo = useSelector((state: any) => state.Auth.userInfo);
  console.log("userInfo", userInfo);
  
  const handleGoToLogin = () => {
    navigate(RouterName.LOGIN + "?backPage=" + route(RouterName.MAIN));
  };

  const avatar = userInfo?.avatar?.url.small || UserAvatar;

  const handleGotoMyInfo = () => {
    navigate(RouterName.MENU);
  }

  const handleToSearchRecipe = () => {
    navigate(RouterName.SEARCH_RECIPES_NATIVE);
  }

  return (
    <div className="w-full">
      <header className="grid grid-cols-3 gap-4 px-[16px] h-[55px] w-full">
        <div className="flex items-center justify-start">
          {userInfo?.id ? (
            <div className="w-[30px] h-[30px]" onClick={handleGotoMyInfo}>
              <img src={avatar} className="rounded-full w-full h-full" alt="" />
            </div>
          ) : (
            <div
              className=""
              onClick={handleGoToLogin}
            >
              <img src={UserAvatar} alt="" />
            </div>
          )}
        </div>
        <div className="flex items-center justify-center">
          <Logo />
        </div>
        <div className="flex items-center justify-end">
          <img src={SearchIcon} alt="" className=""  onClick={handleToSearchRecipe} />
          <CartBadge type="main"/>
          <Bell notiUnread={userInfo?.noti_unread || 0}/>
        </div>
      </header>
    </div>
  );
};

export default MainHeader;
